import React, { useRef, useState } from "react";
import "./Accordion.scss";


const Accordion = ({ title, icon, children, defaultOpen = false, onTitleClick }) => {
    const [open, setOpen] = useState(defaultOpen);
    const contentRef = useRef(null);
    const toggle = () => setOpen((o) => !o);
    const sign = open ? "✕" : "+";

    return (
        <div className={`accordion${open ? " open" : ""}`}>
            {onTitleClick ? (
                // Title has its own action (e.g. navigate), so only the sign toggles.
                <div className="accordion-header">
                    <span className="icon">{icon}</span>
                    <button type="button" className="title" onClick={onTitleClick}>
                        {title}
                    </button>
                    <button type="button" className="expand-sign" onClick={toggle} aria-expanded={open}>
                        {sign}
                    </button>
                </div>
            ) : (
                // Otherwise the whole header row toggles the section.
                <button type="button" className="accordion-header" onClick={toggle} aria-expanded={open}>
                    <span className="icon">{icon}</span>
                    <span className="title">{title}</span>
                    <span className="expand-sign" aria-hidden="true">{sign}</span>
                </button>
            )}
            <div
                className="accordion-content"
                style={
                    open
                        ? { maxHeight: contentRef.current?.scrollHeight }
                        : { maxHeight: 0 }
                }
                ref={contentRef}
            >
                <div className="accordion-inner">{children}</div>
            </div>
        </div>
    );
};
export default Accordion;
